<div class="flex justify-center items-center h-dvh lg:h-screen">
  <div class="w-full max-w-[512px] flex flex-col gap-4 p-4">
    <div class="w-full">
      <img alt="" class="logo !h-20 m-auto" src="logo.png">
    </div>
    @if (token()) {
      <form class="flex flex-col gap-4" #loginForm="ngForm"
            (ngSubmit)="recoveryPassword(loginForm.controls['password'].value, loginForm.controls['confirmPassword'].value)">
        <wun-input black icon-left>
          <wun-profile-icon/>
          <input required name="password" type="password" ngModel placeholder="Password"/>
        </wun-input>
        <wun-input black icon-left>
          <wun-profile-icon/>
          <input required name="confirmPassword" type="password" ngModel placeholder="Confirm Password"/>
        </wun-input>
        <button wunButton primary class="!h-12">
          {{ 'login.recovery' | transloco }}
        </button>
      </form>
    } @else {
      <form class="flex flex-col gap-4" #loginForm="ngForm"
            (ngSubmit)="passwordReset(loginForm.controls['username'].value)">
        <wun-input black icon-left>
          <wun-profile-icon/>
          <input required name="username" type="text" ngModel placeholder="Username"/>
        </wun-input>

        <button wunButton primary class="!h-12">
          {{ 'login.sendRecovery' | transloco }}
        </button>
      </form>
    }

    <div class="w-full flex justify-center">
      <a routerLink="/auth/login">{{ 'login.backToLogin' | transloco }}</a>
    </div>
  </div>
</div>
